import { getMarketDetailRecommend } from '@/axios/market'

const marketDetailRecommend = {
  state: {
    marketDetailRecommend: {}
  },
  mutations: {
    SET_MARKETDETAILRECOMMEND (state, marketDetailRecommend) {
      state.marketDetailRecommend = marketDetailRecommend
    }
  },
  actions: {
    MARKETDETAILRECOMMEND ({ commit }, params) {
      getMarketDetailRecommend(params).then(res => {
        this.state.marketDetailRecommend = res.data.data
      })
    }
  }
}

export default marketDetailRecommend



// WEBPACK FOOTER //
// ./src/store/modules/getMarketDetailRecommend.js